import { store } from '../../../../store';
import { useSelector } from 'react-redux';

/**
 *  @description LOW LEVEL API DO NOT USE
 *  @returns {boolean}
 */
export const allowPacking = () => {
    try {
        return !!JSON.parse(localStorage.user_id).factoryData
            .allowPacking;
    } catch (e) {
        return false;
    }
};

/**
 *  @description LOW LEVEL API DO NOT USE
 *  @returns {boolean}
 */
export const isPackingAllowed = () => {
    try {
        const state = store.getState();
        return (
            state.settings.allowPacking
        );
    } catch (e) {
        return false;
    }
};

/** @returns {boolean}  */
export const usePacking = () =>
    useSelector(({ settings }) => settings.allowPacking);
